/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * A {@link JsonValidator} implementation which performs no validation and accepts all data as valid.
 * @privateRemarks Having this as an option unifies opting out of validation with selection of
 * validators, simplifying code performing validation.
 * @internal
 */
export const noopValidator = {
    compile: () => ({ check: (data) => true }),
};
//# sourceMappingURL=noopValidator.js.map